/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getLoginAttempts} from '../api'

 export const useQueryGetLoginAttempts = createReactQueryHook('getLoginAttempts', getLoginAttempts)
